import { useInvalidateCarriersQuery } from "./use-carriers-query";
import { useApiMutation } from "./use-api-mutation";

export default function useReorderCarriers(shopId: string) {
	return useApiMutation("patch", "/shops/{shopId}/carriers/order", {
		invalidate: useInvalidateCarriersQuery({ shopId }),
		mapVariables: (ids: string[]) => ({
			params: { path: { shopId } },
			body: { ids },
		}),
	});
}
